import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DatetimeComponent } from './components/form/datetime/datetime.component';
import { InputComponent } from './components/form/input/input.component';
import { RadioComponent } from './components/form/radio/radio.component';
import { SelectComponent } from './components/form/select/select.component';
import { TextareaComponent } from './components/form/textarea/textarea.component';
import { ValidationComponent } from './components/form/validation/validation.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';


@NgModule({
  imports: [
    FormsModule,
    TranslateModule,
    CommonModule,
    RouterModule,
    BsDatepickerModule.forRoot(),
    TooltipModule.forRoot(),
  ],
  declarations: [
    DatetimeComponent,
    InputComponent,
    RadioComponent,
    SelectComponent,
    TextareaComponent,
    ValidationComponent
  ],
  exports: [
    DatetimeComponent,
    InputComponent,
    RadioComponent,
    SelectComponent,
    TextareaComponent,
    ValidationComponent,
    BsDatepickerModule
  ]
})
export class SharedModule { }
